/**
 * Representative update request DTO
 */
export class RepresentativeUpdateRequestDTO {
  /**
   * @constructor
   */
  constructor(
    public firstName?: string | null,
    public lastName?: string | null,
    public email?: string | null,
    public picture?: string | null,
    public language?: string | null
  ) {}
}
